<script setup lang="ts">
</script>

<template>
  <router-view />
</template>

<style lang="scss">
@import '@/styles/animate/animate.min.css';
@import url("@/assets/fonts/index.css");
</style>
